import React, { useContext, useEffect, useState } from 'react';
import * as LocationsApi from 'services/locations-api';
import logger from 'services/logger';

type ContextValue = LocationsApi.Location | null;

// Not exported on purpose, use Provider component and hook below
const LocationContext = React.createContext<ContextValue>(null);

export const LocationContextProvider: React.FunctionComponent<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [state, setState] = useState<ContextValue>(null);

  useEffect(() => {
    (async () => {
      try {
        const location = await LocationsApi.getCurrentLocation();

        setState(location);
      } catch (e) {
        logger.error(e);
        setState({});
      }
    })();
  }, []);

  return (
    <LocationContext.Provider value={state}>
      {children}
    </LocationContext.Provider>
  );
};

export function useLocationContext(): ContextValue {
  return useContext(LocationContext);
}
